import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestBody,
  OpalApi,
  OpalApiResponseDocument,
} from '../../schema'

type Operation = 'UpdateStoryV3'
export type UpdateStoryV3RequestBody = OpalApiRequestBody<Operation>

type UpdateStoryV3 = OpalApi<Operation, 200>
type ResponseData = OpalApiResponseDocument<'UpdateStoryV3', 200>

export const update: UpdateStoryV3 = async ({
  params,
  requestBody,
}: Parameters<UpdateStoryV3>[0] = {}) => {
  const storyId = params?.path?.story_id
  if (!storyId) {
    throw new Error('story_id is a required path parameter')
  }

  const url = new URL(`/stories/v3/${storyId}`, window.location.origin)
  const query = params?.query
  url.search = queryString({
    'expose[meta][access]': String(!!query?.expose?.meta?.access),
  })

  return HttpClient()
    .patch<ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
